import React from 'react';
import Manage from './Manage';
import { RolesProvider } from '../../../contexts/RoleContext';


const RolesPage = () => {
    return (
        <RolesProvider>
            <Manage />
        </RolesProvider>
    );
};

export default RolesPage;
